export default function pick<Type>(obj: { [key in string]: unknown }, props: string[]): Type {
  return props.reduce((acc: object, prop) => ({ ...acc, [prop]: obj[prop] }), {}) as Type;
}
